module.exports = "<router-outlet></router-outlet>\n<div class=\"page-loader page-loader--inner\">\n  <div class=\"page-loader__spinner\">\n    <svg viewBox=\"25 25 50 50\">\n      <circle cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\" />\n    </svg>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main